import { clsx } from 'clsx'

import { Table } from '@buffer-mono/popcorn'

import type { ExtraColumn, ListItem } from './helpers'
import { PostItem } from './PostItem'

import styles from './PostItemsTable.module.css'

import type { JSX } from 'react'

export const PostItemsTable = ({
  items,
  extraColumns = [],
  twentyFourHourFormat,
  channelTimezone,
  selectedSaveAction,
}: {
  items: ListItem[]
  extraColumns?: ExtraColumn[]
  twentyFourHourFormat: boolean
  channelTimezone: string
  selectedSaveAction: 'post' | 'draft'
}): JSX.Element => {
  return (
    <Table stickyHeader>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell
            className={clsx(styles.tableHeader, styles.indexHeader)}
          >
            #
          </Table.HeaderCell>
          <Table.HeaderCell
            className={clsx(styles.tableHeader, styles.textHeader)}
          >
            Text
          </Table.HeaderCell>
          <Table.HeaderCell
            className={clsx(styles.tableHeader, styles.imageHeader)}
          >
            Image
          </Table.HeaderCell>
          {extraColumns.map((col) => (
            <Table.HeaderCell
              key={col.key}
              className={clsx(styles.tableHeader, styles.extraColumnHeader)}
              style={{ width: col.width }}
            >
              {col.header}
            </Table.HeaderCell>
          ))}
          <Table.HeaderCell
            className={clsx(styles.tableHeader, styles.tagsHeader)}
          >
            Tags
          </Table.HeaderCell>
          <Table.HeaderCell
            className={clsx(styles.tableHeader, styles.postingTimeHeader)}
          >
            Posting Time
          </Table.HeaderCell>
          <Table.HeaderCell
            className={clsx(styles.tableHeader, styles.statusHeader)}
          >
            Status
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {items.map((item, index) => (
          <PostItem
            key={item.id}
            item={item}
            index={index}
            extraColumns={extraColumns}
            twentyFourHourFormat={twentyFourHourFormat}
            channelTimezone={channelTimezone}
            selectedSaveAction={selectedSaveAction}
          />
        ))}
      </Table.Body>
    </Table>
  )
}
